import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import * as Pages from "./RouterComponent";
import { HomePage, BillingSummaryReportPage, BillingDetailPage, SpecialBillingPage } from "../../utils/PathConfig";
import image from "../../assets/images/404.png"
const Router = (props) => {
  const {
    chiefNo,
    setChiefNo
  } = props;
  const menuDataFromSession = JSON.parse(sessionStorage.getItem("menuData"));

  function toCamelCase(str) {
    return str.replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    );
  }

  const routes = [];
  const componentMap = Pages;

  menuDataFromSession?.forEach((entry) => {
    if (entry?.relativePath) {
      let name = toCamelCase(entry?.relativePath.split("/").pop());
      if (componentMap[name]) {
        routes.push(
          <Route path={entry?.relativePath} element={componentMap[name]} />
        );
      }
    }
    entry?.subMenuList?.forEach((submenu) => {
      if (submenu?.relativePath) {
        let name = toCamelCase(submenu?.relativePath.split("/").pop());
        if (componentMap[name]) {
          routes.push(
            <Route path={submenu?.relativePath} element={componentMap[name]} />
          );
        }
      }
    });
  });

  const PrivateRoute = ({ children }) => {
    if (!chiefNo) {
      return <Navigate to="/" />;
    }
    return children;
  };

  return (
    <Routes>
      <Route path="/" element={<Pages.LoginPage setChiefNo={setChiefNo} />} />
      {routes}
      <Route path={BillingSummaryReportPage} element={<PrivateRoute><Pages.BillingSummaryReport /></PrivateRoute>} />
      <Route path={BillingDetailPage} element={<PrivateRoute><Pages.BillingDetail /></PrivateRoute>} />
      <Route path={HomePage} element={<PrivateRoute><Pages.HomePage /></PrivateRoute>} />
      <Route path={SpecialBillingPage} element={<PrivateRoute><Pages.SpecialofBilling /></PrivateRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const NotFound = () => {
  return (
    <div style={{ paddingBottom: "5.5%", backgroundColor: "white" }} >
      <img src={image} style={{ maxWidth: "100%", maxHeight: '100%' }} />
    </div>
  );
};

export default Router;
